enum ReviewStatus {
  Pending = 1,
  Accepted,
  Rejected,
  ChangesRequested,
  Canceled,
}

export default ReviewStatus;
